import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { authorsApi } from '../api/authors'

const AUTHORS_KEY = 'authors'

export const useAuthors = () => {
  return useQuery({
    queryKey: [AUTHORS_KEY],
    queryFn: authorsApi.getAuthors,
  })
}

export const useCreateAuthor = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: authorsApi.createAuthor,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [AUTHORS_KEY] })
    },
  })
}

export const useSearchAuthors = (query: string) => {
  return useQuery({
    queryKey: [AUTHORS_KEY, 'search', query],
    queryFn: () => authorsApi.searchAuthors(query),
    enabled: query.length >= 2,
  })
}
